import { render, staticRenderFns } from "./UiBadge.vue?vue&type=template&id=1ed2ef7a&"
import script from "./UiBadge.vue?vue&type=script&lang=ts&"
export * from "./UiBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports